// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"a1c83271","502":"dec4c112","2386":"a1c83271","4277":"53fe7ea4","4335":"a1c83271","5061":"5b8f51ee","5065":"a3284052","5508":"aa36243a"}[chunkId] + ".chunk.css";
};